import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// عنوان الـ API الخاص بالسيرفر
const API_URL = `${process.env.REACT_APP_API_URL}/videos`;

// إنشاء thunk لإضافة فيديو جديد
export const addVideo = createAsyncThunk(
    "videos/addVideo",
    async (videoData, thunkAPI) => {
        try {
            const response = await axios.post(API_URL, videoData);
            return response.data; // البيانات التي سيتم إضافتها إلى الحالة
        } catch (error) {
            // تمرير الخطأ إلى واجهة المستخدم
            return thunkAPI.rejectWithValue(error.response.data || error.message);
        }
    }
);

// إنشاء thunk لجلب الفيديوهات من السيرفر
export const fetchVideos = createAsyncThunk(
    "videos/fetchVideos",
    async (_, thunkAPI) => {
        try {
            const response = await axios.get(API_URL);
            return response.data; // جلب الفيديوهات
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data || error.message);
        }
    }
);

// تعريف slice
const videoSlice = createSlice({
    name: "videos",
    initialState: {
        videos: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        // إضافة فيديو
        builder
            .addCase(addVideo.pending, (state) => {
                state.loading = true;
            })
            .addCase(addVideo.fulfilled, (state, action) => {
                state.loading = false;
                state.videos.push(action.payload); // إضافة الفيديو الجديد إلى الحالة
            })
            .addCase(addVideo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        // جلب الفيديوهات
        builder
            .addCase(fetchVideos.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchVideos.fulfilled, (state, action) => {
                state.loading = false;
                state.videos = action.payload; // تحديث قائمة الفيديوهات
            })
            .addCase(fetchVideos.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default videoSlice.reducer;
